import axios from "axios";

export const requestMoveToPostSanctionDocPending = (slug) =>
  axios.request({
    method: "post",
    url: "/api/route?path=application-post-sanction/doc-pending-init",
    data: { slug },
  });
